import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../contexts/LanguageContext';
import GameLayout from './GameLayout';
import PimnasQuiz from './PimnasQuiz';

const QuizPage = () => {
  const { t } = useLanguage();
  usePageTitle(t('trivia.tabQuiz'));

  return (
    <GameLayout title={t('trivia.tabQuiz')} emoji="🧠">
      <PimnasQuiz />
    </GameLayout>
  );
};

export default QuizPage;
